import React from 'react';

function ContactForm() {
  return (
    <footer className="contact-section" id="contatti">
      <div className="contact-info">
        <h2 style={{ fontSize: '40px', marginBottom: '24px' }}>Ci trovi qui.</h2>
        <p style={{ fontSize: '18px', marginBottom: '40px' }}>
          Passa a trovarci o scrivici. Che tu voglia adottare, fare una donazione o ricevere informazioni, la porta è sempre aperta per gli amici dei cani!
        </p>

        <div style={{ marginBottom: '32px' }}>
          <h4 style={{ color: 'var(--color-white)', marginBottom: '8px' }}>Indirizzo</h4>
          <p>Contrada Pezza, Licata (AG)<br />92027 Sicilia</p>
        </div>

        <div style={{ marginBottom: '32px' }}>
          <h4 style={{ color: 'var(--color-white)', marginBottom: '8px' }}>Contatti</h4>
          <p>Email: gladdogs.licata@gmail.com</p>
        </div>

        <div>
          <h4 style={{ color: 'var(--color-white)', marginBottom: '8px' }}>Orari di apertura</h4>
          <p>Tutti i giorni: 09:00 - 13:00 / 15:00 - 18:00</p>
        </div>
      </div>

      <div className="contact-form">
        <h3 style={{ marginBottom: '24px' }}>Scrivici un messaggio</h3>
        <form>
          <div className="form-group">
            <input type="text" placeholder="Il tuo nome" />
          </div>
          <div className="form-group">
            <input type="email" placeholder="La tua email" />
          </div>
          <div className="form-group">
            <select style={{ width: '100%', padding: '16px', border: '1px solid #ddd', borderRadius: '12px', fontFamily: 'var(--font-secondary)' }}>
              <option>Richiesta informazioni</option>
              <option>Voglio adottare</option>
              <option>Voglio fare volontariato</option>
              <option>Altro</option>
            </select>
          </div>
          <div className="form-group">
            <textarea placeholder="Il tuo messaggio"></textarea>
          </div>
          <button type="button" className="btn btn-primary" style={{ width: '100%', padding: '16px' }}>Invia Messaggio</button>
        </form>
      </div>
    </footer>
  );
}

export default ContactForm;
